export interface StrengthResult {
  score: 0 | 1 | 2 | 3 | 4;
  label: string;
  colorVar: string;
}

const LABELS = ['Sehr schwach', 'Schwach', 'Mittel', 'Gut', 'Stark'];
const COLOR_VARS = ['--danger', '--danger', '--warning', '--accent', '--success'];

/**
 * Lightweight heuristic strength meter — length plus character-class variety. Intentionally
 * not a hard gate: it guides the user visually but only blocks submission below a minimal
 * length (see MIN_PASSWORD_LENGTH in main.ts), matching "guide, don't gatekeep."
 */
export function scorePassword(password: string): StrengthResult {
  if (!password) {
    return { score: 0, label: '', colorVar: COLOR_VARS[0] as string };
  }

  let lengthPoints = 0;
  if (password.length >= 8) lengthPoints = 1;
  if (password.length >= 12) lengthPoints = 2;
  if (password.length >= 16) lengthPoints = 3;

  const classes = [/[a-z]/, /[A-Z]/, /[0-9]/, /[^A-Za-z0-9]/];
  const varietyCount = classes.filter((re) => re.test(password)).length;
  const varietyBonus = varietyCount >= 3 ? 1 : 0;

  const score = Math.min(4, lengthPoints + varietyBonus) as StrengthResult['score'];

  return {
    score,
    label: LABELS[score] as string,
    colorVar: COLOR_VARS[score] as string,
  };
}
